import React from 'react';
import '../../styles/RailTile.css';
import PropTypes from 'prop-types';
import { isMobile } from '../../utils/commonUtils';

const PartiallyCancelled = ({
  trainName,
  trainNo,
  trainSrc,
  trainDstn,
  startDate,
  trainType,
  divertedFrom,
  divertedTo
}) => {
  const isMobileDevice = isMobile();
  return (
    <div className="railTile">
      <div className="trainNameNoWrap">
        <span className="blackText latoBlack trainName">{trainName}</span>
        <span className="lightGreyText trainNo">{trainNo}</span>
      </div>
      <div className="trainOtherInfo">
        <div className="stationDateInfo">
          <span className="">{trainSrc}</span>
          <span className="longArrowIcon railSeoSprite appendRight10 appendLeft10"></span>
          <span className="">{trainDstn}</span>
          {isMobileDevice ? (
            <span>
              <span className="appendRight10 appendLeft10">|</span>
              <span className="">{startDate}</span>
              <span className="appendRight10 appendLeft10">|</span>
              <span className="">{trainType}</span>
              <span className="appendRight10 appendLeft10">|</span>
            </span>
          ) : (
            <span className="appendRight10 appendLeft10">{`| ${startDate} |`}</span>
          )}
        </div>
        <div className="cancelInfo">
          <span className="lightGreyText appendRight20">Diverted from</span>
          <span className="pushRight">
            <span className="yellowText">{divertedFrom}</span>
            <span className="orglongArrowIcon railSeoSprite appendRight10 appendLeft10"></span>
            <span className="yellowText">{divertedTo}</span>
          </span>
        </div>
      </div>
    </div>
  );
};

PartiallyCancelled.propTypes = {
  trainName: PropTypes.string,
  trainNo: PropTypes.string,
  trainSrc: PropTypes.string,
  trainDstn: PropTypes.string,
  startDate: PropTypes.string,
  trainType: PropTypes.string,
  divertedFrom: PropTypes.string,
  divertedTo: PropTypes.string
};

export default PartiallyCancelled;
